module.exports = "/_next/static/images/d5f6176b73a211f0c6052aff1cd91e78-mastercard-right-lg.jpg";